const QUOTA_ERROR_NAMES = new Set([
  'QuotaExceededError',
  'NS_ERROR_DOM_QUOTA_REACHED'
]);

interface SafeSetItemOptions {
  context?: string;
  onQuotaExceeded?: () => void;
}

const isQuotaExceededName = (name?: string) =>
  !!name && QUOTA_ERROR_NAMES.has(name);

const isQuotaExceededCode = (code?: number) =>
  code === 22 || code === 1014;

export const isQuotaExceededError = (error: unknown): boolean => {
  if (!error) {
    return false;
  }

  if (typeof DOMException !== 'undefined' && error instanceof DOMException) {
    return isQuotaExceededName(error.name) || isQuotaExceededCode((error as DOMException & { code?: number }).code);
  }

  if (typeof error === 'object' && error !== null) {
    const { name, code } = error as { name?: string; code?: number };
    return isQuotaExceededName(name) || isQuotaExceededCode(code);
  }

  return false;
};

export const safeSetItem = (
  key: string,
  value: string,
  { context = 'localStorage', onQuotaExceeded }: SafeSetItemOptions = {}
) => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    if (isQuotaExceededError(error)) {
      console.warn(`${context}: localStorage quota exceeded when storing "${key}".`, error);
      if (onQuotaExceeded) {
        try {
          onQuotaExceeded();
        } catch (fallbackError) {
          console.warn(`${context}: Fallback after quota exceed failed for "${key}".`, fallbackError);
        }
      }
    } else {
      console.error(`${context}: Failed to write "${key}" to localStorage.`, error);
      throw error;
    }
  }
};

